import { atom } from 'jotai';

export const subscribeDataAtom = atom({
  payDay:"",
  estimatedAmount : 0,
  bank: "",
  companyId: 0,
  cardNumber :"",
  subsData:[],
  isDiscount:false
})
export const payhistoryAtom = atom([]);

export const orderDataAtom = atom({
  address:[],
  createdAt:"",
  paycode:"",
  user:[],
  yaer:0,
  month: 0,
  pay:0,
  photos:[],
});

export const couponNameAtom = atom("");